<template>
  <div class="drawer">
    <h3 class="drawer__title">Onde encontrar dados do médico</h3>
    <div class="drawer__content">
      <p class="drawer__subtitle">Pedido médico</p>
      <p class="drawer__text">
        É o documento onde são listados os exames que precisam ser realizados.
      </p>
    </div>
    <div>
      <p class="drawer__subtitle">Dados do médico</p>
      <p class="drawer__text drawer__line">
        Os dados ficam no pedido médico próximos ao nome ou assinatura do profissional.
      </p>
    </div>
    <VButton text="Entendi" @click.native="$emit('toggle-drawer')" />
    <VButton
      style="margin-top: 8px"
      variant="secondary"
      text="Continuar sem enviar dados"
      @click.native="$emit('go-to-next-page')"
    />
  </div>
</template>

<script>
import { dataLayersMixin } from '@/utils/mixins';

export default {
  mixins: [dataLayersMixin],
  created() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Onde encontrar os dados do profissional (modal)',
    });
  },
};
</script>

<style lang="scss">
.drawer {
  &__title {
    font-weight: 700;
    color: #161616;
    margin-bottom: 24px;
  }

  &__subtitle {
    font-weight: 700;
    color: #666666;
    margin-bottom: 5px;
  }

  &__content {
    margin-bottom: 24px;
  }

  &__text {
    color: #666666;
  }

  &__line {
    border-bottom: 1px solid #666666;
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
}
</style>
